var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlotSize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 7.5C6.75 7.08579 7.08579 6.75 7.5 6.75H10.5C10.9142 6.75 11.25 7.08579 11.25 7.5V10.5C11.25 10.9142 10.9142 11.25 10.5 11.25H7.5C7.08579 11.25 6.75 10.9142 6.75 10.5V7.5Z",
    fill: "#696F88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 2.25H5.25V3.75L12.75 3.75V2.25H14.25V3.75L15.75 3.75V5.25H14.25V12.75H15.75V14.25H14.25V15.75H12.75V14.25L5.25 14.25V15.75H3.75V14.25H2.25V12.75H3.75V5.25H2.25V3.75L3.75 3.75V2.25ZM5.25 12.75V5.25L12.75 5.25V12.75L5.25 12.75Z",
    fill: "#696F88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlotSize);
export default __webpack_public_path__ + "static/media/plotSize.ebce1d16799e94871847215c094b6ab0.svg";
export { ForwardRef as ReactComponent };